import { render, staticRenderFns } from "./ViberPartnerTariff.vue?vue&type=template&id=33421f2a&"
import script from "./ViberPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./ViberPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports